import Image from 'app/Components/Shared/Image/image';
import React from 'react';

const btnWhite = (props) => {
  let className = 'btn-white';
  if (props.className) {
    className += ' ' + props.className;
  }

  return (
    <div className='btn-white-Container'>
      <button className={className} onClick={props.onclick}>
        {props.image && <Image src={props.image} alt='icon' className='btn-white-image' />}
        <span className='btn-white-text'>{props.text}</span>
      </button>
    </div>
  );
};

export default btnWhite;
